module.exports = __webpack_public_path__ + "static/media/partitions_lcs_60y_y.b8fe8fea.csv";